// lpa = louisp autocomplete
angular.module('iconoglobe')
.directive('lpaCountry',["$http", "$q", "$compile", "$location", function($http, $q, $compile, $location){
  return {
    link: function(scope, ele, attrs){


      var canceler = $q.defer();
      var el = angular.element('<ul class="suggestions"/>');
      var el = angular.element("<ul class='extended suggestions'><li ng-repeat='item in countrySuggestions' ng-click='selectCountry(item.country_id)'><a>{{item.value}}</a></li></ul>");
      
      var placeholder = "";
      scope.countrySuggestions = [];
      ele.after(el);
      $compile(el)(scope);
      ele.siblings(".errormsg").hide();
      ele.focus(function(){
        el.show();
      });
      ele.keyup(function (e){
        if(ele.val().length >= attrs.lpaMinlength){
          
          var params = {
            column:"country_name", 
            country : ele.val(),
            timeout: canceler.promise
          };
          scope.showCountryLoading = true;
          
          $http.post("/site/getcountries", params).then(function(res){
              scope.countrySuggestions = res.data;
              scope.showCountryLoading = false;
              ele.siblings(".errormsg").hide();
          }, function(err){
                      
          });
        } else {
          scope.countrySuggestions = [];
          scope.checkKeywordErr();
          scope.$apply();
        }
      })
      ele.blur(function(){
        setTimeout(function(){
          el.hide();
          scope.checkKeywordErr();
        },200)
      });
      scope.selectCountry = function(countryId){
        countryId = parseInt(countryId);
        // scope.countrySuggestions =s [];
        scope.searchCountry = "";
        switch(countryId) {
            case 193:
                $location.path("/russia");
                break;
            case 108:
                $location.path("/india");
                break;
            case 238:
                $location.path("/us");
                break;
            case 41:
                $location.path("/canada");
                break;
            case 46:
                $location.path("/china");
                break;
            default:
                $http.post('/data/getcountrylatlng', {
                  countryId: countryId
                }).then(function(res) {
                  //console.log(res.data);
                  scope.countrySelected(res.data);
                });
        }
        scope.hideKeywordPopup();
        
        // scope.$apply();
      }
      scope.checkKeywordErr = function(){
        if(ele.val().length > 0 && scope.keySuggestions.length < 1){
          ele.addClass("errtxt");
          ele.siblings(".errormsg").show();
        } else {
          ele.removeClass("errtxt");
          ele.siblings(".errormsg").hide();
        }
      }
    }
  }
}])
.directive('lpaKeyword',["$http", "$q", "$compile", "localStorageService", "$document", "UserLocation", "$filter", "LOCALES","cookieStore", function($http, $q, $compile, localStorageService, $document, UserLocation, $filter, LOCALES,cookieStore){
  return {
    link: function(scope, ele, attrs){
      var canceler = $q.defer();

              var el = angular.element("<ul  class='extended suggestions a'><li  ng-repeat='item in keySuggestions' ng-if='item.is_delete != 1' ng-click='selectKeyword($index)'><a id='$index'>{{item.valuekey}}<span>{{item.city}} </span></a></li></ul>");  
							

	
	  var searchResults;
 var langPref = cookieStore.getCookie('lang_pref');
    if (langPref) {
     var localed = LOCALES.locales[langPref];
    } else {
     var localed = LOCALES.locales['en_US'];
    };
   // console.log("localed",localed);
      scope.LOCALES = LOCALES;
 
      ele.after(el);
      $compile(el)(scope);
      scope.keySuggestions = [];
      
      ele.siblings(".errormsg").hide();
      ele.focus(function(){
        el.show();
      })
      var timeoutPromise = null;
      ele.keyup(function (e){
        if(ele.val().length >= attrs.lpaMinlength){
          UserLocation.silently().then(function(data){
            clearTimeout(timeoutPromise);
            timeoutPromise = setTimeout(function() {
             // console.log(canceler);
              canceler.resolve();
              canceler = $q.defer();
              if(!data.lat || !data.long){
                data.lat = 0;
                data.long = 0;
              }
              var keyword = (ele.val() || '').trim();
              var params = {
                keyword : keyword,
                timeout: canceler.promise,
                "latitude":data.lat,
                "longitude":data.long
              };
              scope.showKeywordLoading = true;
            
              $http.post("/data/getkeywords", params).then(function(res){
               
			   
                searchResults = res.data[0];
 
	      var keycountry = $filter('translate')(res.country)

         angular.forEach(res.data[0], function (item, key) {

                    // create a new property valuekey with the item locale name or value
                    if (item.locale && localed[0] == item.locale.language) {
                      res.data[0][key].valuekey = item.locale.name;

                    } else {
                      res.data[0][key].valuekey = item.value;
                    };

                    if (item.type === 'users') {
                      res.data[0][key].info = 'Entertainer/Performer/Sponsor ,' + item.city + ", " + keycountry;
                    } else if
                      (item.type === 'Events') {
                      res.data[0][key].info = 'Event ,' + item.city + ", " + keycountry;
                    } else if
                      (item.type === 'Establishments') {
                      res.data[0][key].info = 'Establishment ,' + item.city + ", " + keycountry;
                    } else {
                      res.data[0][key].info = "KEYWORD";
                    }
                  });
                scope.keySuggestions = res.data[0];
                scope.showKeywordLoading = false;
                scope.checkKeywordErr();
				
				
				

				
				
				
				
				
              }, function(err){});
            }, 500);
            
            var inner_map = angular.element('.globe1');
            var innermapclass = angular.element('.worldmapsec');
			 var inner_mobp = angular.element('.mobmapp');
            var inner_mobpp = angular.element('.mobmap');
			
            var innermapclass_container = angular.element('.extraClass');
            var image_map_Click = angular.element('.glbtran');
			var image_map_Clickb = angular.element('.glbtranb');
            var hasMystyle = inner_map.hasClass('zoomSection');
            var hasMyclass = innermapclass.hasClass('zoomSection');
			var hasMyclass2 = inner_mobp.hasClass('zoomSection');
			var hasMyclass3 = inner_mobpp.hasClass('zoomSection');
            var hasMystyle_container = innermapclass.hasClass('afterClass');
            var image_map_Class = image_map_Click.hasClass('showingImage');
			var image_map_Classb = image_map_Clickb.hasClass('showingImage');


            if (hasMystyle === true) {
				inner_map.addClass('mapstyle');
            }
            if (hasMyclass === true) {
			     innermapclass.addClass('mapstyle');
            }
			   if (hasMyclass2 === true) {
				inner_mobp.addClass('mapstyle');
            }
			   if (hasMyclass3 === true) {
				inner_mobpp.addClass('mapstyle');
            }
            if (hasMystyle_container === true) {
                innermapclass.removeClass('afterClass');
            }
            if (image_map_Class === false) {
                image_map_Click.addClass('showingImage');
            }
			 if (image_map_Classb === false) {
                image_map_Clickb.addClass('showingImage');
            }
			 if (hasMystyle === true) {
                inner_map.removeClass('zoomSection');
			
            }
            if (hasMyclass === true) {
                innermapclass.removeClass('zoomSection');
			
            }
			   if (hasMyclass2 === true) {
                inner_mobp.removeClass('zoomSection');
			
            }
			   if (hasMyclass3 === true) {
                inner_mobpp.removeClass('zoomSection');
			
            }
            
          });
        } else {  
          scope.keySuggestions = [];
          scope.checkKeywordErr();
          scope.$apply();
        }
      });
      ele.blur(function(){
        setTimeout(function(){
          el.hide();
          ele.removeClass("errtxt");
          ele.siblings(".errormsg").hide();
        },250);
      });
      scope.selectKeyword = function(idx){
        var selectedKeyword = searchResults[idx];
        // scope.keySuggestions = [];
        ele.val(selectedKeyword.value);
        localStorageService.set('selectedKeyword', JSON.stringify(selectedKeyword));
        scope.keywordSelected(selectedKeyword);
		scope.hideKeywordPopup();
         
      }
      scope.checkKeywordErr = function(){
        if(ele.val().length > 0 && scope.keySuggestions.length < 1){
          ele.addClass("errtxt");
          ele.siblings(".errormsg").show();
        } else {
          ele.removeClass("errtxt");
          ele.siblings(".errormsg").hide();
        }
      }
      
    }
  }
}])
